module.exports = __webpack_public_path__ + "img/gPayPending.43c6acd6.svg";